'use strict';

var React = require('react');
module.exports = function () {
  return React.createElement('svg', { xmlns: 'http://www.w3.org/2000/svg', viewBox: '135.1 -517.4 1024 1024', width: '12', height: '12' }, React.createElement('path', { className: 'c1', d: 'M137.3-195c0 17.4 7.4 34.7 19.8 47.1l441.4 409.1c27.3 24.8 71.9 24.8 99.2 0l438.9-429c27.3-24.8 27.3-66.9 0-91.7-27.3-24.8-71.9-24.8-99.2 0L648.1 122.3 256.3-242.2c-27.3-24.8-71.9-24.8-99.2 0-12.4 14.9-19.8 29.8-19.8 47.2z' }));
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/arrowDown.svg.js